import { render, staticRenderFns } from "./TabLocalization.vue?vue&type=template&id=0287d1f5"
import script from "./TabLocalization.vue?vue&type=script&lang=ts"
export * from "./TabLocalization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports